import en from './en.json'
import it from './it.json'

export const verificationsTranslations = {
	en,
	it
} as const
